import { BaseApi } from 'Core/api/BaseApi'

const groupsEN = {
  'svi-djelovi': 'all-parts',
  'gume': 'tires',
  'akumulatori': 'battery',
  'ulja-i-maziva': 'oils-and-lubricants',
  'filteri': 'filters',
  'karoserija': 'car-body',
  'univerzalno': 'universal',
  'alati-i-oprema': 'tools-and-equipment',
}

export class Api extends BaseApi {
  getFilteredFields = async ({ group, payload }) => {
    let defaultResponse = { data: { group: [], category: [], car_brand: [], car_model: [], year: [], vehicle_type: [], car_model_engine_info: [], car_models_main: [], years_models: [] } }

    if (group === 'gume') defaultResponse.data = { tire_vehicle_type: [], season: [], width: [], height: [], diameter: [], manufacturer: [], }
    if (group === 'akumulatori') defaultResponse.data = { voltage: [], capacity: [], width: [], height: [], length: [], manufacturer: [], }
    if (['ulja-i-maziva', 'ulja-i-maziva', 'filteri', 'karoserija', 'univerzalno', 'alati-i-oprema'].includes(group)) {
      defaultResponse.data = { category: [], manufacturer: [], car_brand: [], car_model: [], year: [], vehicle_type: [], car_model_engine_info: [], car_models_main: [], years_models: [] }
    }

    try {
      const groupEN = groupsEN[group]

      const groupSlug = group !== 'svi-djelovi' ? `/${groupEN}` : ''

      // const { body } = await Api.get(`/search_fields${group === 'svi-djelovi' ? '' : `/${groupEN}`}`, payload, process.env.NEXT_PUBLIC_WEB_SHOP_API_HOST)
      const { body } = await Api.get(`/search_fields${groupSlug}`, payload, process.env.NEXT_PUBLIC_WEB_SHOP_API_HOST)

      if (body && body.data) return body

      return defaultResponse
    } catch (e) {
      defaultResponse.error = e
      return defaultResponse
    }
  }
}
